import { connect } from 'react-redux';
import ItemMessage from './ItemMessage';
import { getPhoneNumber } from '../../../../../utils/index';

const mapStateToProps = ({ originReducer }, ownProps) => {
  const {
    isCustomerViewingCustomProduct, isMandi, invalid, isDiscontinued, isCopyStylesErrorMsg,
  } = ownProps;
  const { mode } = originReducer;
  const phoneNumber = getPhoneNumber(mode);

  return {
    phoneNumber,
    isCustomerViewingCustomProduct,
    isMandi,
    invalid,
    isDiscontinued,
    isCopyStylesErrorMsg,
  };
};

export default connect(mapStateToProps)(ItemMessage);
